import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import Loader from "components/Loader/Loader";
import ThriveSignatureRequests from 'apis/ThriveSignatureRequest/ThriveSignatureRequest';
import { PDFDownloadLink } from "@react-pdf/renderer";
// import ThriveSignaturePDF from "./ThriveSignaturePDF";
import EnrollmentThriveStartUpPDF from './EnrollmentThriveStartUpPDF';

const PreviewToPdf = ({ formData, formFields, open, onClose }) => {
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        setTimeout(() => setLoader(false), 0);
    }, []);

    const formattedCreatedAt = formData?.created_at || formData?.createdAt
  ? new Date(formData.created_at || formData.createdAt).toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    })
  : "-";

  

    if (!open) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0, 0, 0, 0.4)", // dim effect only, no blur                
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <div
                style={{
                    background: "#555", // soft inner background
                    borderRadius: "8px",
                    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
                    width: "80%",
                    maxWidth: "800px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    padding: "24px",
                    position: "relative"
                }}
            >


                <div style={{ float: "right" }}>
                
                <PDFDownloadLink
                    document={<EnrollmentThriveStartUpPDF formData={formData} formFields={formFields} />}
                    fileName='ThriveSignature_Form.pdf'
                    style={{
                    textDecoration: "none",
                    padding: "10px 20px",
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginRight:"40px",
                  
                    }}
                >
                    {({ loading }) => (loading ? "Preparing PDF..." : "Download as PDF")}
                </PDFDownloadLink>
            
                                
                    <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#fff" }}>
                        <CloseIcon />
                    </button>
                </div>
                <div className="preview-wrapper">
                    {!loader ? <div className="preview-container">
                        <div className="preview-header">
                            <span className="date"><strong>Submitted Date:</strong>{formattedCreatedAt}</span>
                            <h2>
                                Henry Schein Thrive Signature Enrollment Form
                            </h2>
                        </div>

                        <div className="preview-body">
                            {formFields.map((field, index) => (
                                <div className="row" key={index}>
                                    <strong>{field.label}</strong>
                                    <span className={(field.key === "title") || (field.key === "subscription_plan") || (field.key === "state") ? "tag" : ""}>
                                        {formData[field.key] || "-"}
                                    </span>
                                </div>
                            ))}
                        </div>
                        <div style={{ fontSize: "13px", color: "#333", lineHeight: "1.5", padding: 40 }}>
                            <p>
                                I agree: (i) to place this order and agree to the related terms electronically, and (ii) to the terms and conditions of the{" "}
                                <a
                                    href={formData?.thrivesignatureLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#1a0dab", textDecoration: "underline" }}
                                >
                                    Thrive Signature Service Agreement.
                                </a>
                            </p>
                            <p>
                                Placing this order also includes your acceptance and agreement to our program{" "}
                                <a
                                    href={formData?.thrivesignaturetermconditionLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#1a0dab", textDecoration: "underline" }}
                                >
                                    Terms and Conditions.
                                </a>{" "}
                                Please read them before placing this order.
                            </p>
                            <div><strong>Signature</strong></div>
                            <img src={formData?.signature} alt="signature" />
                        </div>

                        <style>{`

        .preview-wrapper {
            padding: 10px;
        }

        .preview-container {
          max-width: 679px;
          margin: 40px auto;          
          background: #ffffff;
          border: 1px solid #ddd;
          font-family: 'Segoe UI', sans-serif;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }

        .preview-header {
          background: #f1f4ff;
          padding: 40px 40px 10px 40px;
          margin-bottom: 30px;
          position: relative;
          text-align: center;
        }

        .preview-header .date {
          position: absolute;
          top: 10px;
          right: 20px;
          font-size: 14px;
          color: #555;
        }

        .preview-header h2 {
          font-size: 20px;
          color: #222;
          margin-top: 20px;
        }

        .preview-body {
          padding: 0 40px;
        }

        .row {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid #eee;
        }

        .row strong {
          flex: 1;
          font-weight: 600;
          color: #333;
        }

        .row span {
          flex: 2;
          text-align: left;
          color: #444;
        }

        .tag {
          display: inline-block;
          background: #e0e7ff;
          color: #1a237e;
          padding: 4px 12px;
          border-radius: 6px;
          font-weight: 500;
          width: fit-content;
        }
      `}</style>
                    </div> : <div style={{ height: "100vh", display: "flex", alignItems: "center" }}><Loader /></div>}
                </div>
            </div>
        </div>
    );
};

export default PreviewToPdf;
